// Centralized URL Configuration
// This file contains all hardcoded URLs used across the project

const CONFIG = {
  // Frontend URLs
  FRONTEND: {
    PORT: 3003,
    URL: ''
  },
  
  // Backend URLs (use relative paths for production, Caddy will proxy)
  BACKEND: {
    PORT: 5001,
    BASE_URL: '',
    API_BASE_URL: '/api',
    DASHBOARD_API_URL: '/api/dashboard'
  },
  
  // Database URLs (updated for VPS)
  DATABASE: {
    MONGODB_URL: 'mongodb://localhost:27017/',
    MONGODB_WEBSITE_URL: 'mongodb://localhost:27017/inuka-website'
  },
  
  // System IPs
  SYSTEM: {
    LOCALHOST_IP: '127.0.0.1'
  }
};

module.exports = CONFIG;
